// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/routes/assessment/routes/Loading/style.scss
// module id = 749
// module chunks = 0